export default "__VITE_ASSET__251c36bb__"